export const emailAddress: string = 'mikeminor.creativetechnologist@gmail.com';

export default emailAddress;
